import { useEffect, useState } from "react";
import api, { fmtDT } from "@/lib/api";
import { PageHeader, MetricCard, Loading } from "@/components/Shared";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, PieChart, Pie, Cell, Legend } from "recharts";
import { Users, Building2, ShoppingCart, Wallet, Clock, Truck, Newspaper, UserCheck } from "lucide-react";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <Loading />;

  const pie = [
    { name: "Actifs", value: s.pharmacists_active, color: "#10b981" },
    { name: "En attente", value: s.pharmacists_pending, color: "#f59e0b" },
  ];
  const bars = s.top_operations.map((o) => ({ name: o.name.length > 18 ? o.name.slice(0, 18) + "…" : o.name, Engagé: o.committed, Objectif: o.objective }));

  return (
    <div>
      <PageHeader title="Tableau de bord" subtitle="Vue d'ensemble de l'activité de la plateforme." />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <MetricCard testId="admin-metric-pharmacists" label="Pharmaciens" value={s.pharmacists} icon={Users} tone="indigo" />
        <MetricCard testId="admin-metric-pending" label="À valider" value={s.pharmacists_pending} icon={UserCheck} tone="amber" />
        <MetricCard testId="admin-metric-suppliers" label="Fournisseurs" value={s.suppliers} icon={Building2} tone="sky" />
        <MetricCard testId="admin-metric-volume" label="Volume engagé" value={fmtDT(s.total_committed)} icon={Wallet} tone="emerald" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <MetricCard label="Opérations ouvertes" value={s.operations_open} icon={ShoppingCart} tone="emerald" />
        <MetricCard label="Opérations clôturées" value={s.operations_closed} icon={Clock} tone="indigo" />
        <MetricCard label="Commandes" value={s.orders} icon={Truck} tone="sky" />
        <MetricCard label="Actualités" value={s.news} icon={Newspaper} tone="rose" />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-6">
          <h3 className="font-bold text-slate-900 mb-4">Top opérations — engagé vs objectif</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={bars} margin={{ left: -10 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
              <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#94a3b8" }} />
              <YAxis tick={{ fontSize: 11, fill: "#94a3b8" }} />
              <Tooltip formatter={(v) => fmtDT(v)} />
              <Bar dataKey="Objectif" fill="#e2e8f0" radius={[4, 4, 0, 0]} />
              <Bar dataKey="Engagé" fill="#4f46e5" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-6">
          <h3 className="font-bold text-slate-900 mb-4">Pharmaciens</h3>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={pie} dataKey="value" nameKey="name" innerRadius={55} outerRadius={85} paddingAngle={3}>
                {pie.map((e, i) => <Cell key={i} fill={e.color} />)}
              </Pie>
              <Legend />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
